import { useState } from "react";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

import { formatSimplePrice } from "../helpers";
import { saveListingSearch } from "../service";
import TextInput from "@shared/v2/TextInput";

const SaveSearchModal = ({ search, onClose, userId }) => {
  const [saving, setSaving] = useState(false);
  const [name, setName] = useState(generateDefaultSearchName(search));

  const save = async () => {
    setSaving(true);
    await saveListingSearch(userId, name, search);
    setSaving(false);
    onClose(true);
  };

  return (
    <Modal
      id="save-search-modal"
      show={true}
      onHide={onClose}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[640px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Save Search" />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
        <span className="tw-text-14px tw-text-gray-75">
          The current locations and filters will be saved for you.
        </span>
        <TextInput
          value={name}
          onChange={(e) => setName(e.target.value)}
          label="Name the search"
          isRequired
        />
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" disabled={!name} isLoading={saving} onClick={save}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveSearchModal;

const generateDefaultSearchName = (search) => {
  const formattedLocations = [];
  LocationFormatters.forEach(({ field, textFormatter }) => {
    const locations = search[field]?.map(textFormatter);
    if (locations?.length) {
      formattedLocations.push(...locations);
    }
  });

  let defaultName = formattedLocations.join("; ");

  defaultName += createMinMaxDescription(
    formatSimplePrice(search.priceMin),
    formatSimplePrice(search.priceMax),
    null,
    "$0",
  );
  defaultName += createMinMaxDescription(search.bedsMin, search.bedsMax, "beds");
  defaultName += createMinMaxDescription(search.bathsMin, search.bathsMax, "baths");
  defaultName += createMinMaxDescription(search.sqFtMin, search.sqFtMax, "SQFT");

  return defaultName;
};

const LocationFormatters = [
  { field: "cityStates", textFormatter: (c) => `${c.city}, ${c.state}` },
  { field: "neighborhoodCityStates", textFormatter: (n) => `${n.neighborhood}, ${n.city}, ${n.state}` },
  { field: "countyStates", textFormatter: (cs) => `${cs.county}, ${cs.state}` },
  { field: "postalCodes", textFormatter: (p) => p },
  { field: "mlsNums", textFormatter: (m) => m },
  { field: "streetAddress", textFormatter: (s) => s },
];

const createMinMaxDescription = (min, max, descriptor = "", base = "0") => {
  if (!min && !max) {
    return "";
  }

  return `; ${min ? min : base}${max ? "-" + max : "+"}${descriptor ? " " + descriptor : ""}`;
};
